import { BRACKET_ROUND_ROBIN_ACTION } from "../../core/constants/Actions";
import { Action } from "../../core/models/ActionTypes";
import { BracketResult } from "../../core/models/Bracket";

const initialState: {
  bracketResult: BracketResult[] | null;
  isLoading: boolean;
} = {
  bracketResult: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: {
    bracketResult: BracketResult[];
  };
}

export default function bracketRoundRobinResultReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_ROUND_ROBIN_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_ROUND_ROBIN_ACTION.SUCCESS:
      const { bracketResult } = action.payload;
      return { ...state, bracketResult, isLoading: false };

    case BRACKET_ROUND_ROBIN_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
